import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';

function BidTable({ bids }) {
  if (!bids || bids.length === 0) {
    return <p>No bids available.</p>;
  }
console.log("Bids Data:", bids); // Debugging line to check the data structure
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Bid ID</TableCell>
            <TableCell>Bid Mode</TableCell>
            <TableCell>Bidding time</TableCell>
            <TableCell>Rider Fee</TableCell>
            <TableCell>Driver Name</TableCell>
            <TableCell>Driver Phone</TableCell>
            <TableCell>Service Associated</TableCell>
            <TableCell>Base Amount</TableCell>
            <TableCell>Discount</TableCell>
            <TableCell>Discount Reason</TableCell>
            <TableCell>Discounted Price</TableCell>
            <TableCell>Tax (Total)</TableCell>
            <TableCell>IGST</TableCell>
            <TableCell>Platform Fee</TableCell>
            <TableCell>Platform Fee Discount</TableCell>
            <TableCell>Final Amount</TableCell>
            
            <TableCell>Updated At</TableCell>
           
          </TableRow>
        </TableHead>
        <TableBody>
          {bids.map((bid) => (
            <TableRow key={bid._id}>
              <TableCell>{bid._id}</TableCell>
              <TableCell>{bid.bidMode}</TableCell>
              <TableCell>
                {new Date(bid.created_at).toLocaleString()}
              </TableCell>
              <TableCell>{bid.riderFee}</TableCell>
              <TableCell>
                {bid.rider
                  ? `${bid.rider.first_name} ${bid.rider.last_name}`
                  : 'N/A'}
              </TableCell>
              <TableCell>
                {bid.rider ? bid.rider.phone_number : 'N/A'}
              </TableCell>
              <TableCell>{bid.serviceAssociated}</TableCell>
              <TableCell>
                {bid.pricing.baseAmount?.value || 'N/A'}
              </TableCell>
              <TableCell>
                {bid.pricing.discount?.value || 'N/A'}
              </TableCell>
              <TableCell>
                {bid.pricing.discount?.config?.reason || 'N/A'}
              </TableCell>
              <TableCell>
                {bid.pricing.discountedPrice?.value || 'N/A'}
              </TableCell>
              <TableCell>
                {bid.pricing.tax?.total?.value || 'N/A'}
              </TableCell>
              <TableCell>
                {bid.pricing.tax?.igst?.value || 'N/A'}
              </TableCell>
              <TableCell>
                {bid.pricing.platformFee?.netFee?.value || 'N/A'}
              </TableCell>
              <TableCell>
                {bid.pricing.platformFee?.discount?.value || 'N/A'}
              </TableCell>
              <TableCell>{bid.pricing.finalAmount || 'N/A'}</TableCell>
             
              <TableCell>
                {new Date(bid.updated_at).toLocaleString()}
              </TableCell>
              
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default BidTable;
